export default __webpack_public_path__ + "static/media/shopifyIcon.b16c50d5.svg";